import { Moment } from 'moment';

export enum weekDayType {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface workTimeList {
  endTime?: string;
  startTime?: string;
  userId: number;
  id?: number;
  weekDay: weekDayType;
}

export interface UserWorkTimeControllerRequest {
  workTimeList: workTimeList[];
}

export interface UserWorkTimeControllerFormValues {
  MONDAY?: Moment[];
  TUESDAY?: Moment[];
  WEDNESDAY?: Moment[];
  THURSDAY?: Moment[];
  FRIDAY?: Moment[];
  SATURDAY?: Moment[];
  SUNDAY?: Moment[];
  fill?: Moment[];
}
